import styles from "./styles.module.css";
import { FaArrowRight, FaCircleNotch, FaHeadphonesAlt } from "react-icons/fa";
import { ButtonProps } from "../../types/form";

const Button = ({
  onClick,
  type = "submit",
  title,
  size = "medium",
  bgColor,
  className,
  disabled,
  loading,
  style,
}: ButtonProps) => {
  const variant = bgColor || className || "orange";
  const variantClass = styles[variant] || "";
  const externalClass = className && !styles[className] ? className : "";

  return (
    <div className={`${styles.InputContainer} ${styles[size || "medium"]}`}>
      <button
        type={type}
        onClick={onClick}
        className={`${styles.button} ${variantClass} ${externalClass}`}
        disabled={disabled || loading}
        style={style}
      >
        <span className={styles.buttonGlow} aria-hidden="true" />
        <span className={styles.buttonContent}>
          {loading ? (
            <FaCircleNotch className={`${styles.buttonIcon} ${styles.spin}`} />
          ) : (
            <FaHeadphonesAlt className={styles.buttonIcon} />
          )}
          <span>{loading ? "Please wait" : title}</span>
          {!loading && <FaArrowRight className={styles.buttonArrow} />}
        </span>
      </button>
    </div>
  );
};

export default Button;
